// Hocs
import asyncRoute from '../AsyncRoute'

// Exports
export function getComponent ({store}) {
  return new Promise((resolve) => {
    require.ensure([], (require) => {
      const View = require('hfty-contact-us').ContactUsForm

      resolve(View)

    /* Webpack named bundle   */
    }, 'contact-us')
  })
}

export default asyncRoute({getComponent, reducers: []})
